import{extractCurrentRoute as t}from"@grandvisionhq/utils";const n=(n,e)=>{const l=t(n).split("/");let s,g;return e&&(s=l[l.length-1]),!e&&l.length>1&&(s=l[l.length-2],g=l[l.length-1]),{slug:s,sku:g}};export{n as e};
//# sourceMappingURL=extract-product-from-route-da9c20a3.js.map
